import React from 'react';

import {outdatedMessage} from '#Client/components/ClientAppVersionMismatchModal/ClientAppVersionMismatchModal.css';
import {IMG_DIR} from '#Client/components/constants';
import {IconButton} from '#Client/components/IconButton/IconButton';
import {Modal} from '#Client/components/Modal/Modal';
import {trackEvent} from '#Client/components/util';

type Props = {
  onClose: () => void;
};

export const ClientAppVersionMismatchModal = ({onClose}: Props) => {
  const refresh = () => {
    trackEvent(
      'click',
      'client-app-version-mismatch-modal',
      'button',
      'refresh',
    );
    location.reload();
  };
  return (
    <Modal
      image={`${IMG_DIR}icon_stopwatch.png`}
      title="New version available"
      onClose={onClose}
    >
      <>
        <h2>New version available!</h2>
        <div className={outdatedMessage}>
          Your app version is outdated. Please click below to get the latest
          version.
        </div>
        <div className="textAlignCenter">
          <IconButton
            icon="btn_icon_puzzle.png"
            large
            text="Play"
            onClick={refresh}
          />
        </div>
      </>
    </Modal>
  );
};
